module.exports = __webpack_public_path__ + "media/assets/images/blog/contact_flow_example-small-ab1322db5684cb9955d92a5672e5e831.png";